import { apiService } from './apiService';

/** Row returned from POST /inventory/upload-products-excel */
export interface ExcelProductRowParsed {
  row_number: number;
  name?: string | null;
  code?: string | null;
  category_name?: string | null;
  category_id?: number | null;
  barcode?: string | null;
  unit_of_measure?: string;
  cost_price?: number | string;
  selling_price?: number | string;
  minimum_stock_level?: number;
  maximum_stock_level?: number;
  description?: string | null;
  opening_quantity?: number;
  valid: boolean;
  error?: string | null;
  warnings?: string[];
}

export interface ProductsExcelParseResponse {
  success: boolean;
  total_rows: number;
  valid_rows: ExcelProductRowParsed[];
  invalid_rows: ExcelProductRowParsed[];
  errors: string[];
  create_payload?: Record<string, unknown>[] | null;
  column_mapping: Record<string, string | null>;
  ignored_columns: string[];
  parse_notes: string[];
}

export interface CreateProductsFromExcelResponse {
  created: Array<{ id: number; name: string; code: string }>;
  failed: Array<{ row: number; error: string }>;
  created_count: number;
  failed_count: number;
}

export const bulkInventoryService = {
  async uploadProductsExcel(file: File): Promise<ProductsExcelParseResponse> {
    const formData = new FormData();
    formData.append('file', file);
    return apiService.upload<ProductsExcelParseResponse>('/inventory/upload-products-excel', formData);
  },

  async createProductsFromExcel(body: {
    items: Record<string, unknown>[];
    inventory_location_id?: number | null;
  }): Promise<CreateProductsFromExcelResponse> {
    return apiService.post<CreateProductsFromExcelResponse>('/inventory/create-products-from-excel', {
      items: body.items,
      inventory_location_id: body.inventory_location_id ?? null,
    });
  },
};
